const validateSyntax = (email: string) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(email)) {
    return true;
  }
  return false;
};

export { validateSyntax };
